module.exports = __webpack_public_path__ + "assets/link.1a80d273.svg";